// extracted by mini-css-extract-plugin
module.exports = {"container":"_3pfypLkxH7VbFzg41s5zht","item":"_8Es-zDfZhPX8srDN0bEhk","dot":"_1qofVbptPW-jpxFZjnarxD","externalId":"_2twSdhn79Ee1pb_INZHYjA"};